/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="table-tile" :title="item.name" :sub-title="item.sku">
    <div class="table-tile__item">
      <div class="table-tile__item-block block-media block-first">
        <img-product
        :imgPath="imagePath"
        size="LG"
        :styleImage="{ maxWidth: '100%' }"
        />
      </div>
      <div class="table-tile__item-block block-name">
        <div class="block-info__name">
          <span class="title" v-html="item.name"></span>
        </div>
      </div>
      <div class="table-tile__item-block block-options">
        <div class="block-info__current-options" v-if="selectedOptions">
          <product-selected-options :variants="selectedOptions"></product-selected-options>
        </div>
      </div>
      <div class="table-tile__item-block block-price">
        <div class="price-header">
          <div class="label">{{ $t('price') }}</div>
          <div class="label">{{ $t('order.discount') }}</div>
          <div class="label">{{ $t('total') }}</div>
        </div>
        <div class="price-body">
          <div class="wrapp-price unit-price">
            <span class="value">{{ price | price($store) }}</span>
          </div>
          <div class="wrapp-price discount-price">
            <span class="value">{{ item.discount_amount | price($store) }}</span>
          </div>
          <div class="wrapp-price total-price">
            <span class="value">{{ rowTotal | price($store) }}</span>
          </div>
        </div>
      </div>
      <div class="table-tile__item-block block-qty">
        <div class="label">{{ $t('Quantity') }}</div>
        <span class="value t-regular">{{ item.qty_ordered }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Config from '@/config'
import ProductPrice from 'theme/components/Listing/ProductPrice'
import ImgProduct from 'theme/components/Product/Image'
import ProductSelectedOptions from 'theme/components/Product/ProductSelectedOptions'

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    shipment: {
      type: Object,
      required: false
    }
  },
  computed: {
    stockStatus () {
      return this.item && this.item.is_in_stock ? this.item.is_in_stock : 'STOCK-ERROR'
    },
    imagePath () {
      let url = ''
      if (this.item.extension_attributes && this.item.extension_attributes.image_url) {
        url = this.item.extension_attributes.image_url
      }
      return url
    },
    rowTotal () {
      return Config.Theme.priceIncludeTax ? this.item.row_total_incl_tax : this.item.row_total
    },
    price () {
      return Config.Theme.priceIncludeTax ? this.item.price_incl_tax : this.item.price
    },
    selectedOptions () {
      if (this.item.extension_attributes && this.item.extension_attributes.selected_options.length) {
        return this.item.extension_attributes.selected_options
      }
    }
  },
  components: {
    ImgProduct,
    ProductPrice,
    ProductSelectedOptions
  }
}
</script>
